import { createAuthClient } from "better-auth/react";

/**
 * A third Better Auth client, pointed at the third Better Auth instance
 * (`apps/api/src/contractor-portal-auth.ts`) — never the staff one in
 * `auth-client.ts`, never the client-portal one in `portal-auth-client.ts`.
 *
 * Same-origin, so no `baseURL` is needed here either. None of the three
 * sessions collide in the same browser because each *server* instance uses a
 * distinct `basePath` and `advanced.cookiePrefix`, giving each client's
 * cookie a different name.
 */
export const contractorPortalAuthClient = createAuthClient({
  basePath: "/api/contractor-portal/auth",
});

export const {
  signIn: contractorPortalSignIn,
  signUp: contractorPortalSignUp,
  signOut: contractorPortalSignOut,
  useSession: useContractorPortalSession,
} = contractorPortalAuthClient;
